/**
 * isiZulu: Help guides
 *
 * What this file covers: The help tours, step-by-step how-tos, the question marks beside settings tabs and the
 * written guides with their checklists.
 *
 * Tone: A patient teacher speaking to the reader as you. Short sentences. Step titles start with their number
 * and an action. Names of buttons, tabs and pages must match exactly what the console shows in this language,
 * so translate these after the pages they describe.
 *
 * isiZulu: Everyday isiZulu as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const guides: Catalog = {};

export default guides;
